import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

// URL and endpoint constants
const API_URL = process.env.API_BASE_URL

const getOpcoesTabelaEstruturada = (codTabela) => {
  const OPCOES_URL = API_URL + '/opcoes/' + codTabela
  let config = {
    method: 'get',
    url: OPCOES_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getProjetoSIEX = (registroSIEX) => {
  const IMPORTAR_URL = API_URL + '/projetos/importar/' + registroSIEX
  let config = {
    method: 'get',
    url: IMPORTAR_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getRelatorioProjeto = (idProjeto) => {
  const RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorio'
  let config = {
    method: 'get',
    url: RELATORIO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getMeusProjetos = (idProjeto) => {
  const MEUS_PROJETOS_URL = API_URL + '/meus-projetos'
  let config = {
    method: 'get',
    url: MEUS_PROJETOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getMeusProjetosAtivos = (idProjeto) => {
  const MEUS_PROJETOS_URL = API_URL + '/meus-projetos-ativos'
  let config = {
    method: 'get',
    url: MEUS_PROJETOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getConsultaProjetos = (pesquisa) => {
  const PROJETOS_URL = API_URL + '/projetos'
  let config = {
    method: 'get',
    url: PROJETOS_URL,
    params: pesquisa,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getConsultaRelatoriosTecnicos = (pesquisa) => {
  const RELATORIOS_TECNICOS_URL = API_URL + '/relatorios-tecnicos'
  let config = {
    method: 'get',
    url: RELATORIOS_TECNICOS_URL,
    params: pesquisa,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getProjeto = (idProjeto) => {
  const PROJETO_URL = API_URL + '/projetos/' + idProjeto
  let config = {
    method: 'get',
    url: PROJETO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const deleteProjeto = (idProjeto) => {
  const PROJETO_URL = API_URL + '/projetos/' + idProjeto
  let config = {
    method: 'delete',
    url: PROJETO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getClassificacoesPossiveis = (item) => {
  const CLASSIFICACOES_URL = API_URL + '/classificacoes/' + item
  let config = {
    method: 'get',
    url: CLASSIFICACOES_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getClassificacoesAreasDoConhecimento = () => {
  const CLASSIFICACOES_URL = API_URL + '/classificacoes/areas-do-conhecimento'
  let config = {
    method: 'get',
    url: CLASSIFICACOES_URL,
    responseType: 'text'
  }
  return Vue.http(config)
}

const getClassificacoesClassificacaoSuperior = (idClassifSup) => {
  const CLASSIFICACOES_URL = API_URL + '/classificacoes/classificacao-superior/' + idClassifSup
  let config = {
    method: 'get',
    url: CLASSIFICACOES_URL,
    responseType: 'text'
  }
  return Vue.http(config)
}

const getClassificacoesDoProjeto = (idProjeto) => {
  const CLASSIFICACOES_URL = API_URL + '/projetos/' + idProjeto + '/classificacoes'
  let config = {
    method: 'get',
    url: CLASSIFICACOES_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getExtensaoDoProjeto = (idProjeto) => {
  const EXTENSAO_URL = API_URL + '/projetos/' + idProjeto + '/extensao'
  let config = {
    method: 'get',
    url: EXTENSAO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getContatosDoProjeto = (idProjeto) => {
  const CONTATOS_URL = API_URL + '/projetos/' + idProjeto + '/contatos'
  let config = {
    method: 'get',
    url: CONTATOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getIntegrantesDoProjeto = (idProjeto) => {
  const PARTICIPANTES_URL = API_URL + '/projetos/' + idProjeto + '/participantes'
  let config = {
    method: 'get',
    url: PARTICIPANTES_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getVinculosDoProjeto = (idProjeto) => {
  const VINCULOS_URL = API_URL + '/projetos/' + idProjeto + '/vinculos'
  let config = {
    method: 'get',
    url: VINCULOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getParceriasDoProjeto = (idProjeto) => {
  const PARCERIAS_URL = API_URL + '/projetos/' + idProjeto + '/parcerias'
  let config = {
    method: 'get',
    url: PARCERIAS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getAtividadesDoProjeto = (idProjeto) => {
  const ATIVIDADES_URL = API_URL + '/projetos/' + idProjeto + '/atividades'
  let config = {
    method: 'get',
    url: ATIVIDADES_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getSuspensoes = (idProjeto) => {
  const SUSPENSOES_URL = API_URL + '/projetos/' + idProjeto + '/suspensao'
  let config = {
    method: 'get',
    url: SUSPENSOES_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getAtividade = (idProjeto, idAtividade) => {
  const ATIVIDADES_URL = API_URL + '/projetos/' + idProjeto + '/atividades/' + idAtividade
  let config = {
    method: 'get',
    url: ATIVIDADES_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const deleteAtividade = (idProjeto, idAtividade) => {
  const ATIVIDADES_URL = API_URL + '/projetos/' + idProjeto + '/atividades/' + idAtividade
  let config = {
    method: 'delete',
    url: ATIVIDADES_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const getParceria = (idProjeto, idParceria) => {
  const PARCERIAS_URL = API_URL + '/projetos/' + idProjeto + '/parcerias/' + idParceria
  let config = {
    method: 'get',
    url: PARCERIAS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const putAtividade = (idProjeto, idAtividade, atividade) => {
  const ATIVIDADES_URL = API_URL + '/projetos/' + idProjeto + '/atividades/' + idAtividade
  let config = {
    method: 'put',
    url: ATIVIDADES_URL,
    responseType: 'text',
    credentials: true,
    body: atividade
  }
  return Vue.http(config)
}

const getBolsasDoProjeto = (idProjeto) => {
  const BOLSAS_URL = API_URL + '/projetos/' + idProjeto + '/bolsas'
  let config = {
    method: 'get',
    url: BOLSAS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getArquivosDoProjeto = (idProjeto) => {
  const ARQUIVOS_URL = API_URL + '/projetos/' + idProjeto + '/arquivos'
  let config = {
    method: 'get',
    url: ARQUIVOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getArquivo = (idProjeto, idArquivo) => {
  const ARQUIVOS_URL = API_URL + '/projetos/' + idProjeto + '/arquivos/' + idArquivo + '/informacoes'
  let config = {
    method: 'get',
    url: ARQUIVOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getIntegrante = (idProjeto, idParticipante) => {
  const PARTICIPANTE_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idParticipante
  let config = {
    method: 'get',
    url: PARTICIPANTE_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const deleteIntegrante = (idProjeto, idIntegrante) => {
  const INTEGRANTES_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idIntegrante
  let config = {
    method: 'delete',
    url: INTEGRANTES_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const getPessoasPorNome = (nome) => {
  const PESSOAS_URL = API_URL + '/pessoas'
  let config = {
    method: 'get',
    url: PESSOAS_URL,
    responseType: 'text',
    credentials: true,
    params: {nome: nome}
  }
  return Vue.http(config)
}

const getPessoasPorCpf = (cpf) => {
  const PESSOAS_URL = API_URL + '/pessoas'
  let config = {
    method: 'get',
    url: PESSOAS_URL,
    responseType: 'text',
    credentials: true,
    params: {cpf: cpf}
  }
  return Vue.http(config)
}

const getPessoa = (idPessoa) => {
  const PESSOA_URL = API_URL + '/pessoas/' + idPessoa
  let config = {
    method: 'get',
    url: PESSOA_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const putPessoa = (idPessoa, pessoa) => {
  const PESSOA_URL = API_URL + '/pessoas/' + idPessoa
  let config = {
    method: 'put',
    url: PESSOA_URL,
    responseType: 'text',
    credentials: true,
    body: pessoa
  }
  return Vue.http(config)
}

const getUnidadesExtensao = () => {
  const UNIDADES_URL = API_URL + '/unidades'
  let config = {
    method: 'get',
    url: UNIDADES_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getUnidades = (tipoUnidadeItem) => {
  const UNIDADES_URL = API_URL + '/unidades/tipo/' + tipoUnidadeItem
  let config = {
    method: 'get',
    url: UNIDADES_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const postIntegrante = (idProjeto, integrante) => {
  const PARTICIPANTE_URL = API_URL + '/projetos/' + idProjeto + '/participantes'
  let config = {
    method: 'post',
    url: PARTICIPANTE_URL,
    responseType: 'text',
    credentials: true,
    body: integrante
  }
  return Vue.http(config)
}

const postImportarProjetoSIEX = (registroSIEX, projetoSIEX) => {
  const IMPORTAR_URL = API_URL + '/projetos/importar/' + registroSIEX
  let config = {
    method: 'post',
    url: IMPORTAR_URL,
    responseType: 'text',
    credentials: true,
    body: projetoSIEX
  }
  return Vue.http(config)
}

const putIntegrante = (idProjeto, idParticipante, integrante) => {
  const PARTICIPANTE_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idParticipante
  let config = {
    method: 'put',
    url: PARTICIPANTE_URL,
    responseType: 'json',
    credentials: true,
    body: integrante
  }
  return Vue.http(config)
}

const putCoordenador = (idProjeto, idParticipante) => {
  const COORDENADOR_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idParticipante + '/novoCoordenador'
  let config = {
    method: 'put',
    url: COORDENADOR_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const postProjeto = (projeto) => {
  const PROJETOS_URL = API_URL + '/projetos'
  let config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'json',
    credentials: true,
    body: projeto
  }
  return Vue.http(config)
}

const postClassificacoesDoProjeto = (idProjeto, classificacoes) => {
  const CLASSIFICACOES_URL = API_URL + '/projetos/' + idProjeto + '/classificacoes'
  let config = {
    method: 'post',
    url: CLASSIFICACOES_URL,
    responseType: 'json',
    credentials: true,
    body: classificacoes
  }
  return Vue.http(config)
}

const postParceriasDoProjeto = (idProjeto, parceria) => {
  const PARCERIAS_URL = API_URL + '/projetos/' + idProjeto + '/parcerias'
  let config = {
    method: 'post',
    url: PARCERIAS_URL,
    responseType: 'json',
    credentials: true,
    body: parceria
  }
  return Vue.http(config)
}

const putParceriasDoProjeto = (idProjeto, idParceria, parceria) => {
  const PARCERIAS_URL = API_URL + '/projetos/' + idProjeto + '/parcerias/' + idParceria
  let config = {
    method: 'put',
    url: PARCERIAS_URL,
    responseType: 'json',
    credentials: true,
    body: parceria
  }
  return Vue.http(config)
}

const postAtividadesDoProjeto = (idProjeto, atividade) => {
  const ATIVIDADES_URL = API_URL + '/projetos/' + idProjeto + '/atividades'
  let config = {
    method: 'post',
    url: ATIVIDADES_URL,
    responseType: 'json',
    credentials: true,
    body: atividade
  }
  return Vue.http(config)
}

const putProjeto = (idProjeto, projeto) => {
  const PROJETO_URL = API_URL + '/projetos/' + idProjeto
  let config = {
    method: 'put',
    url: PROJETO_URL,
    responseType: 'json',
    credentials: true,
    body: projeto
  }
  return Vue.http(config)
}

const postExtensao = (idProjeto, extensao) => {
  const EXTENSAO_URL = API_URL + '/projetos/' + idProjeto + '/extensao'
  let config = {
    method: 'post',
    url: EXTENSAO_URL,
    responseType: 'json',
    credentials: true,
    body: extensao
  }
  return Vue.http(config)
}

const postContatos = (idProjeto, contatos) => {
  const CONTATOS_URL = API_URL + '/projetos/' + idProjeto + '/contatos'
  let config = {
    method: 'post',
    url: CONTATOS_URL,
    responseType: 'json',
    credentials: true,
    body: contatos
  }
  return Vue.http(config)
}

const postRelatorio = (idProjeto, relatorio) => {
  const RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios/extensao'
  let config = {
    method: 'post',
    url: RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: relatorio
  }
  return Vue.http(config)
}

const postBolsista = (idProjeto, bolsista) => {
  const BOLSISTA_URL = API_URL + '/projetos/' + idProjeto + '/bolsistas'
  let config = {
    method: 'post',
    url: BOLSISTA_URL,
    responseType: 'json',
    credentials: true,
    body: bolsista
  }
  return Vue.http(config)
}

const postArquivo = (idProjeto, arquivo) => {
  const ARQUIVOS_URL = API_URL + '/projetos/' + idProjeto + '/arquivos'
  let config = {
    method: 'post',
    url: ARQUIVOS_URL,
    responseType: 'json',
    credentials: true,
    body: arquivo
  }
  return Vue.http(config)
}

const putArquivo = (idProjeto, idArquivo, arquivo) => {
  const ARQUIVOS_URL = API_URL + '/projetos/' + idProjeto + '/arquivos/' + idArquivo
  let config = {
    method: 'put',
    url: ARQUIVOS_URL,
    responseType: 'json',
    credentials: true,
    body: arquivo
  }
  return Vue.http(config)
}

const deleteArquivo = (idProjeto, idArquivo) => {
  const ARQUIVOS_URL = API_URL + '/projetos/' + idProjeto + '/arquivos/' + idArquivo
  let config = {
    method: 'delete',
    url: ARQUIVOS_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const deleteParceria = (idProjeto, idParceria) => {
  const PARCERIAS_URL = API_URL + '/projetos/' + idProjeto + '/parcerias/' + idParceria
  let config = {
    method: 'delete',
    url: PARCERIAS_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const getListaLocalidade = (idProjeto) => {
  const LOCALIDADES_URL = API_URL + '/projetos/' + idProjeto + '/localidades'
  let config = {
    method: 'get',
    url: LOCALIDADES_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const getLocalidade = (idProjeto, idLocalidade) => {
  const LOCALIDADES_URL = API_URL + '/projetos/' + idProjeto + '/localidades/' + idLocalidade
  let config = {
    method: 'get',
    url: LOCALIDADES_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const postLocalidade = (idProjeto, localidade) => {
  const LOCALIDADES_URL = API_URL + '/projetos/' + idProjeto + '/localidades'
  let config = {
    method: 'post',
    url: LOCALIDADES_URL,
    responseType: 'json',
    credentials: true,
    body: localidade
  }
  return Vue.http(config)
}

const putLocalidade = (idProjeto, idLocalidade, localidade) => {
  const LOCALIDADES_URL = API_URL + '/projetos/' + idProjeto + '/localidades/' + idLocalidade
  let config = {
    method: 'put',
    url: LOCALIDADES_URL,
    responseType: 'json',
    credentials: true,
    body: localidade
  }
  return Vue.http(config)
}

const deleteLocalidade = (idProjeto, idLocalidade) => {
  const LOCALIDADES_URL = API_URL + '/projetos/' + idProjeto + '/localidades/' + idLocalidade
  let config = {
    method: 'delete',
    url: LOCALIDADES_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const getCidades = (ufCidadeItem) => {
  const CIDADES_URL = API_URL + '/cidades/' + ufCidadeItem
  let config = {
    method: 'get',
    url: CIDADES_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const getEstados = (itemPais) => {
  const ESTADOS_URL = API_URL + '/estados/' + itemPais
  let config = {
    method: 'get',
    url: ESTADOS_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

const postPessoa = (pessoa) => {
  const PESSOA_URL = API_URL + '/pessoas'
  let config = {
    method: 'post',
    url: PESSOA_URL,
    responseType: 'text',
    credentials: true,
    body: pessoa
  }
  return Vue.http(config)
}

const getAcaoExtensao = (registro) => {
  const ACAO_EXTENSAO_URL = API_URL + '/acoes-extensao?registro=' + registro
  let config = {
    method: 'get',
    url: ACAO_EXTENSAO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const postSubmissaoAprovacao = (idProjeto) => {
  const SUBMISSAO_URL = API_URL + '/projetos/' + idProjeto + '/submissao-aprovacao'
  let config = {
    method: 'post',
    url: SUBMISSAO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const postConcluirImportacao = (idProjeto) => {
  const IMPORTACAO_URL = API_URL + '/projetos/' + idProjeto + '/conclui-importacao'
  let config = {
    method: 'post',
    url: IMPORTACAO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const postAprovarProjeto = (idProjeto, aprovacao) => {
  const APROVACAO_URL = API_URL + '/projetos/' + idProjeto + '/aprovacao'
  let config = {
    method: 'post',
    url: APROVACAO_URL,
    responseType: 'text',
    credentials: true,
    body: aprovacao
  }
  return Vue.http(config)
}

const postDevolverProjeto = (idProjeto, devolucao) => {
  const DEVOLUCAO_URL = API_URL + '/projetos/' + idProjeto + '/devolucao'
  let config = {
    method: 'post',
    url: DEVOLUCAO_URL,
    responseType: 'text',
    credentials: true,
    body: devolucao
  }
  return Vue.http(config)
}

const postLiberarRelatorioFinal = (idProjeto) => {
  const LIBERACAO_URL = API_URL + '/projetos/' + idProjeto + '/liberacao-relatorio-final'
  let config = {
    method: 'post',
    url: LIBERACAO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const postInabilitarProjeto = (idProjeto, inabilitacao) => {
  const INABILITACAO_URL = API_URL + '/projetos/' + idProjeto + '/inabilitacao'
  let config = {
    method: 'post',
    url: INABILITACAO_URL,
    responseType: 'text',
    credentials: true,
    body: inabilitacao
  }
  return Vue.http(config)
}

const postAlterarClassificacaoSecundaria = (idProjeto, alteracao) => {
  const ALTERACAO_URL = API_URL + '/projetos/' + idProjeto + '/classificacao-secundaria'
  let config = {
    method: 'post',
    url: ALTERACAO_URL,
    responseType: 'text',
    credentials: true,
    body: alteracao
  }
  return Vue.http(config)
}

const postSuspenderAcaoExtensao = (idProjeto, suspensao) => {
  const SUSPENSAO_URL = API_URL + '/projetos/' + idProjeto + '/suspensao'
  let config = {
    method: 'post',
    url: SUSPENSAO_URL,
    responseType: 'text',
    credentials: true,
    body: suspensao
  }
  return Vue.http(config)
}

const postReativarAcaoExtensao = (idProjeto, reativacao) => {
  const REATIVACAO_URL = API_URL + '/projetos/' + idProjeto + '/reativacao'
  let config = {
    method: 'post',
    url: REATIVACAO_URL,
    responseType: 'text',
    credentials: true,
    body: reativacao
  }
  return Vue.http(config)
}

const postProrrogarSuspensaoAcaoExtensao = (idProjeto, suspensao) => {
  const SUSPENSAO_URL = API_URL + '/projetos/' + idProjeto + '/prorrogacao-suspensao'
  let config = {
    method: 'post',
    url: SUSPENSAO_URL,
    responseType: 'text',
    credentials: true,
    body: suspensao
  }
  return Vue.http(config)
}

const postSubmissaoConclusao = (idProjeto) => {
  const CONCLUSAO_URL = API_URL + '/projetos/' + idProjeto + '/submissao-conclusao'
  let config = {
    method: 'post',
    url: CONCLUSAO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getParcerias = () => {
  const PARCERIAS_URL = API_URL + '/parcerias'
  let config = {
    method: 'get',
    url: PARCERIAS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getOcorrenciasIntegrante = (idProjeto, idParticipante) => {
  const OCORRENCIAS_INTEGRANTE_URL = API_URL + '/projetos/' + idProjeto + '/participantes/' + idParticipante + '/ocorrencias'
  let config = {
    method: 'get',
    url: OCORRENCIAS_INTEGRANTE_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const postFinalizarProjeto = (idProjeto, finalizacao) => {
  const FINALIZAR_PROJETO_URL = API_URL + '/projetos/' + idProjeto + '/finalizar'
  let config = {
    method: 'post',
    url: FINALIZAR_PROJETO_URL,
    responseType: 'text',
    credentials: true,
    body: finalizacao
  }
  return Vue.http(config)
}

const postConcluirProjeto = (idProjeto, conclusao) => {
  const CONCLUIR_PROJETO_URL = API_URL + '/projetos/' + idProjeto + '/concluir'
  let config = {
    method: 'post',
    url: CONCLUIR_PROJETO_URL,
    responseType: 'text',
    credentials: true,
    body: conclusao
  }
  return Vue.http(config)
}

const postCancelarProjeto = (idProjeto, cancelamento) => {
  const CANCELAR_PROJETO_URL = API_URL + '/projetos/' + idProjeto + '/cancelar'
  let config = {
    method: 'post',
    url: CANCELAR_PROJETO_URL,
    responseType: 'text',
    credentials: true,
    body: cancelamento
  }
  return Vue.http(config)
}

const postDesfazerFinalizacaoProjeto = (idProjeto, cancelamento) => {
  const DESFAZER_FINALIZACAO_PROJETO_URL = API_URL + '/projetos/' + idProjeto + '/desfazer-finalizacao'
  let config = {
    method: 'post',
    url: DESFAZER_FINALIZACAO_PROJETO_URL,
    responseType: 'text',
    credentials: true,
    body: cancelamento
  }
  return Vue.http(config)
}

const postDesfazerExclusaoProjeto = (idProjeto, cancelamento) => {
  const CANCELAR_PROJETO_URL = API_URL + '/projetos/' + idProjeto + '/desfazer-exclusao'
  let config = {
    method: 'post',
    url: CANCELAR_PROJETO_URL,
    responseType: 'text',
    credentials: true,
    body: cancelamento
  }
  return Vue.http(config)
}

const getRelatoriosGestao = () => {
  const RELATORIOS_GESTAO_URL = API_URL + '/gestao/relatorios'
  let config = {
    method: 'get',
    url: RELATORIOS_GESTAO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const postProjetoSuperior = (idProjeto, idProjetoSuperior) => {
  const PROJETO_SUPERIOR_URL = API_URL + '/projetos/' + idProjeto + '/superior/' + idProjetoSuperior
  let config = {
    method: 'post',
    url: PROJETO_SUPERIOR_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getProjetosVencidos = () => {
  const PROJETOS_VENCIDOS_URL = API_URL + '/projetos-preenchimento-incompleto-mais-seis-meses'
  let config = {
    method: 'get',
    url: PROJETOS_VENCIDOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getProjetosComRelatorioReprovavel = () => {
  const PROJETOS_RELATORIO_REPROVAVEL = API_URL + '/projetos-relatorio-reprovavel'
  let config = {
    method: 'get',
    url: PROJETOS_RELATORIO_REPROVAVEL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getRegistrosDeEnvioDeRelatorioDeProjeto = (idProjeto) => {
  const REGISTROS_ENVIO_RELATORIOS_PROJETO = API_URL + '/projetos/' + idProjeto + '/registro-envio-relatorio'
  let config = {
    method: 'get',
    url: REGISTROS_ENVIO_RELATORIOS_PROJETO,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getListaMensagem = () => {
  const MENSAGEM_URL = API_URL + '/mensagem'
  let config = {
    method: 'get',
    url: MENSAGEM_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const postMensagem = (mensagem) => {
  const MENSAGEM_URL = API_URL + '/mensagem'
  let config = {
    method: 'post',
    url: MENSAGEM_URL,
    responseType: 'text',
    credentials: true,
    body: mensagem
  }
  return Vue.http(config)
}

const deleteProjetoSuperior = (idProjeto, idProjetoSuperior) => {
  const SUPERIOR_URL = API_URL + '/projetos/' + idProjeto + '/superior/' + idProjetoSuperior
  let config = {
    method: 'delete',
    url: SUPERIOR_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getDuplicacao = (idProjeto) => {
  const DUPLICACAO_URL = API_URL + '/projetos/' + idProjeto + '/duplicacao'
  let config = {
    method: 'get',
    url: DUPLICACAO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const postDuplicacao = (idProjeto, duplicacao) => {
  const DUPLICACAO_URL = API_URL + '/projetos/' + idProjeto + '/duplicacao'
  let config = {
    method: 'post',
    url: DUPLICACAO_URL,
    responseType: 'text',
    credentials: true,
    body: duplicacao
  }
  return Vue.http(config)
}

const getRelatoriosDoProjeto = (idProjeto) => {
  const RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos'
  let config = {
    method: 'get',
    url: RELATORIO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getRelatorioExtensao = (idProjeto, idRelatorio) => {
  const RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorio
  let config = {
    method: 'get',
    url: RELATORIO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const postRelatorioExtensao = (idProjeto, relatorioExtensao) => {
  const RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/'
  let config = {
    method: 'post',
    url: RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: relatorioExtensao
  }
  return Vue.http(config)
}

const putRelatorioExtensao = (idProjeto, idRelatorioExtensao, relatorioExtensao) => {
  const RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao
  let config = {
    method: 'put',
    url: RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: relatorioExtensao
  }
  return Vue.http(config)
}

const postSubmeterRelatorio = (idProjeto, idRelatorioExtensao, submissao) => {
  const SUBMETER_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao + '/submissao'
  let config = {
    method: 'post',
    url: SUBMETER_RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: submissao
  }
  return Vue.http(config)
}

const postAprovarRelatorio = (idProjeto, idRelatorioExtensao, aprovacao) => {
  const APROVAR_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao + '/aprovacao'
  let config = {
    method: 'post',
    url: APROVAR_RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: aprovacao
  }
  return Vue.http(config)
}

const postDevolverRelatorio = (idProjeto, idRelatorioExtensao, devolucao) => {
  const DEVOLVER_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao + '/devolucao'
  let config = {
    method: 'post',
    url: DEVOLVER_RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: devolucao
  }
  return Vue.http(config)
}

const postReprovarRelatorio = (idProjeto, idRelatorioExtensao, reprovacao) => {
  const REPROVAR_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao + '/reprovacao'
  let config = {
    method: 'post',
    url: REPROVAR_RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: reprovacao
  }
  return Vue.http(config)
}

const postRegistrarEnvioDeRelatorioDeProjeto = (idProjeto, payload) => {
  const REGISTRO_ENVIO_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/registro-envio-relatorio'
  let config = {
    method: 'post',
    url: REGISTRO_ENVIO_RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: payload
  }
  return Vue.http(config)
}

const deleteRegistroEnvioDeRelatorioDeProjeto = (idProjeto, idRegistroRelatorioProjeto) => {
  const DELETE_REGISTRO_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/registro-envio-relatorio/' + idRegistroRelatorioProjeto
  let config = {
    method: 'delete',
    url: DELETE_REGISTRO_RELATORIO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const putRegistroEnvioDeRelatorioDeProjeto = (idProjeto, idRegistroRelatorioProjeto, payload) => {
  const PUT_REGISTRO_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/registro-envio-relatorio' + '/' + idRegistroRelatorioProjeto
  let config = {
    method: 'put',
    url: PUT_REGISTRO_RELATORIO_URL,
    responseType: 'text',
    credentials: true,
    body: payload
  }
  return Vue.http(config)
}

const postReprovarRelatorioComSuspensaoDeCoordenador = (idProjeto, payload) => {
  const REPROVAR_RELATORIO_SUSPENSAO_COORDENADOR_URL = API_URL + '/projetos/' + idProjeto + '/reprovar-relatorio-suspender-coordenador'
  let config = {
    method: 'post',
    url: REPROVAR_RELATORIO_SUSPENSAO_COORDENADOR_URL,
    responseType: 'text',
    credentials: true,
    body: payload
  }
  return Vue.http(config)
}

const postAtivarAdministrador = () => {
  const ATIVAR_ADMINISTRADOR_URL = API_URL + '/ativa-administrador'
  let config = {
    method: 'post',
    url: ATIVAR_ADMINISTRADOR_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const postDesativarAdministrador = () => {
  const DESATIVAR_ADMINISTRADOR_URL = API_URL + '/desativa-administrador'
  let config = {
    method: 'post',
    url: DESATIVAR_ADMINISTRADOR_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getPrazoDias = (idProjeto) => {
  const URL = API_URL + '/projetos/' + idProjeto + '/prazo-dias'
  let config = {
    method: 'get',
    url: URL,
    responseType: 'text'
  }
  return Vue.http(config)
}

const getRelatorioTecnicoForaPrazo = (idProjeto, idRelatorioExtensao) => {
  const URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao + '/relatorio-fora-prazo'
  let config = {
    method: 'get',
    url: URL,
    responseType: 'text'
  }
  return Vue.http(config)
}

const getVerificarPendenciasRelatorio = (idProjeto, idRelatorioExtensao) => {
  const VERIFICAR_PENDENCIAS_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + idRelatorioExtensao + '/validar'
  let config = {
    method: 'get',
    url: VERIFICAR_PENDENCIAS_RELATORIO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getPeriodoRelatorio = (idProjeto) => {
  const PERIODO_RELATORIO_URL = API_URL + '/projetos/' + idProjeto + '/relatorios-tecnicos/' + 'novo'
  let config = {
    method: 'get',
    url: PERIODO_RELATORIO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getEmailCargaHorariaCoordenador = (idProjeto) => {
  const EMAIL_CARGA_HORARIA_COORDENADOR_URL = API_URL + '/projetos/' + idProjeto + '/coordenador'
  let config = {
    method: 'get',
    url: EMAIL_CARGA_HORARIA_COORDENADOR_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getExcadServer = () => {
  const EXCAD_SERVER_URL = API_URL + '/excad-server'
  let config = {
    method: 'get',
    url: EXCAD_SERVER_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

const getDocumentoProtocolo = (documento) => {
  const PROTOCOLO_SERVER_URL = 'https://api.lepisma.ufes.br/documentos'
  let config = {
    method: 'get',
    url: PROTOCOLO_SERVER_URL,
    params: documento,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Cadastra um novo projeto de pesquisa.
const postProjetoPesquisa = (projetoPesquisa) => {
  const PROJETOS_URL = API_URL + '/pesquisa/projetos'
  let config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'text',
    credentials: true,
    body: projetoPesquisa
  }
  return Vue.http(config)
}

// Consulta projetos de pesquisa.
const getConsultaProjetosPesquisa = (consulta) => {
  const PROJETOS_URL = API_URL + '/pesquisa/projetos'
  let config = {
    method: 'get',
    url: PROJETOS_URL,
    params: consulta,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Envia um projeto de pesquisa para registro.
const postProjetoPesquisaRegistro = (idProjetoPesquisa) => {
  const PROJETOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/registro'
  let config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Registra um projeto de pesquisa.
const postRegistrarProjetoPesquisa = (idProjetoPesquisa) => {
  const PROJETOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/aprovacao'
  let config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Devolve um projeto de pesquisa.
const postDevolverProjetoPesquisa = (idProjetoPesquisa) => {
  const PROJETOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/devolucao'
  let config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Conclui um projeto de pesquisa.
const postConcluirProjetoPesquisa = (idProjetoPesquisa) => {
  const PROJETOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/conclusao'
  let config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Cancela um projeto de pesquisa.
const postCancelarProjetoPesquisa = (idProjetoPesquisa) => {
  const PROJETOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/cancelamento'
  let config = {
    method: 'post',
    url: PROJETOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Retorna os projetos de pesquisa dos quais o usuário logado faz parte.
const getMeusProjetosPesquisa = () => {
  const MEUS_PROJETOS_URL = API_URL + '/pesquisa/meus-projetos'
  let config = {
    method: 'get',
    url: MEUS_PROJETOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Retorna um determinado projeto de pesquisa.
const getProjetoPesquisa = (idProjetoPesquisa) => {
  const PROJETO_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa
  let config = {
    method: 'get',
    url: PROJETO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Retorna as instituições de um projeto de pesquisa.
const getInstituicoesProjetoPesquisa = (idProjetoPesquisa) => {
  const INSTITUICOES_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/instituicoes'
  let config = {
    method: 'get',
    url: INSTITUICOES_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Retorna os participantes de um projeto de pesquisa.
const getParticipantesProjetoPesquisa = (idProjetoPesquisa) => {
  const PARTICIPANTES_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/participantes'
  let config = {
    method: 'get',
    url: PARTICIPANTES_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Retorna os órgãos financiadores de um projeto de pesquisa.
const getOrgaosFinanciadoresProjetoPesquisa = (idProjetoPesquisa) => {
  const ORGAOS_FINANCIADORES_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/orgaos-financiadores'
  let config = {
    method: 'get',
    url: ORGAOS_FINANCIADORES_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Retorna os arquivos de um projeto de pesquisa.
const getArquivosProjetoPesquisa = (idProjetoPesquisa) => {
  const ARQUIVOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/arquivos'
  let config = {
    method: 'get',
    url: ARQUIVOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Edita um projeto de pesquisa.
const putProjetoPesquisa = (idProjetoPesquisa, projetoPesquisa) => {
  const PROJETO_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa
  let config = {
    method: 'put',
    url: PROJETO_URL,
    responseType: 'text',
    credentials: true,
    body: projetoPesquisa
  }
  return Vue.http(config)
}

// Pesquisa órgãos financiadores por nome.
const getPesquisaOrgaosFinanciadoresPorNome = (nome) => {
  const PESQUISA_ORGAOS_FINANCIADORES_URL = API_URL + '/pesquisa/orgaos-financiadores'
  let config = {
    method: 'get',
    url: PESQUISA_ORGAOS_FINANCIADORES_URL,
    responseType: 'text',
    credentials: true,
    params: {nome: nome}
  }
  return Vue.http(config)
}

// Pesquisa órgãos financiadores por sigla.
const getPesquisaOrgaosFinanciadoresPorSigla = (sigla) => {
  const PESQUISA_ORGAOS_FINANCIADORES_URL = API_URL + '/pesquisa/orgaos-financiadores'
  let config = {
    method: 'get',
    url: PESQUISA_ORGAOS_FINANCIADORES_URL,
    responseType: 'text',
    credentials: true,
    params: {sigla: sigla}
  }
  return Vue.http(config)
}

// Retorna um determinado órgão financiador.
const getOrgaoFinanciador = (idOrgaoFinanciador) => {
  const ORGAO_FINANCIADOR_URL = API_URL + '/pesquisa/orgaos-financiadores/' + idOrgaoFinanciador
  let config = {
    method: 'get',
    url: ORGAO_FINANCIADOR_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Adiciona um órgão financiador a um projeto de pesquisa.
const postOrgaoFinanciadorProjetoPesquisa = (idProjetoPesquisa, orgaoFinanciadorProjetoPesquisa) => {
  const ORGAO_FINANCIADOR_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/orgaos-financiadores'
  let config = {
    method: 'post',
    url: ORGAO_FINANCIADOR_URL,
    responseType: 'text',
    credentials: true,
    body: orgaoFinanciadorProjetoPesquisa
  }
  return Vue.http(config)
}

// Retorna um determinado órgão financiador de um projeto de pesquisa.
const getOrgaoFinanciadorProjetoPesquisa = (idProjetoPesquisa, idOrgaoFinanciadorProjetoPesquisa) => {
  const ORGAO_FINANCIADOR_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/orgaos-financiadores/' + idOrgaoFinanciadorProjetoPesquisa
  let config = {
    method: 'get',
    url: ORGAO_FINANCIADOR_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Edita um órgão financiador de um projeto de pesquisa.
const putOrgaoFinanciadorProjetoPesquisa = (idProjetoPesquisa, idOrgaoFinanciadorProjetoPesquisa, orgaoFinanciadorProjetoPesquisa) => {
  const ORGAO_FINANCIADOR_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/orgaos-financiadores/' + idOrgaoFinanciadorProjetoPesquisa
  let config = {
    method: 'put',
    url: ORGAO_FINANCIADOR_URL,
    responseType: 'text',
    credentials: true,
    body: orgaoFinanciadorProjetoPesquisa
  }
  return Vue.http(config)
}

// Exclui um órgão financiador de um projeto de pesquisa.
const deleteOrgaoFinanciadorProjetoPesquisa = (idProjetoPesquisa, idOrgaoFinanciadorProjetoPesquisa) => {
  const ORGAO_FINANCIADOR_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/orgaos-financiadores/' + idOrgaoFinanciadorProjetoPesquisa
  let config = {
    method: 'delete',
    url: ORGAO_FINANCIADOR_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

// Cadastra um novo órgão financiador.
const postOrgaoFinanciador = (orgaoFinanciador) => {
  const ORGAO_FINANCIADOR_URL = API_URL + '/pesquisa/orgaos-financiadores'
  let config = {
    method: 'post',
    url: ORGAO_FINANCIADOR_URL,
    responseType: 'text',
    credentials: true,
    body: orgaoFinanciador
  }
  return Vue.http(config)
}

// Pesquisa instituições por nome.
const getPesquisaInstituicoesPorNome = (nome) => {
  const PESQUISA_INSTITUICOES_URL = API_URL + '/pesquisa/instituicoes'
  let config = {
    method: 'get',
    url: PESQUISA_INSTITUICOES_URL,
    responseType: 'text',
    credentials: true,
    params: {nome: nome}
  }
  return Vue.http(config)
}

// Pesquisa instituições por sigla.
const getPesquisaInstituicoesPorSigla = (sigla) => {
  const PESQUISA_INSTITUICOES_URL = API_URL + '/pesquisa/instituicoes'
  let config = {
    method: 'get',
    url: PESQUISA_INSTITUICOES_URL,
    responseType: 'text',
    credentials: true,
    params: {sigla: sigla}
  }
  return Vue.http(config)
}

// Retorna uma determinada instituição
const getInstituicao = (idInstituicao) => {
  const INSTITUICAO_URL = API_URL + '/pesquisa/instituicoes/' + idInstituicao
  let config = {
    method: 'get',
    url: INSTITUICAO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Adiciona uma instituição a um projeto de pesquisa.
const postInstituicaoProjetoPesquisa = (idProjetoPesquisa, instituicaoProjetoPesquisa) => {
  const INSTITUICAO_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/instituicoes'
  let config = {
    method: 'post',
    url: INSTITUICAO_URL,
    responseType: 'text',
    credentials: true,
    body: instituicaoProjetoPesquisa
  }
  return Vue.http(config)
}

// Retorna uma determinada instituição de um projeto de pesquisa.
const getInstituicaoProjetoPesquisa = (idProjetoPesquisa, idInstituicaoProjetoPesquisa) => {
  const INSTITUICAO_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/instituicoes/' + idInstituicaoProjetoPesquisa
  let config = {
    method: 'get',
    url: INSTITUICAO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Edita uma instituição de um projeto de pesquisa.
const putInstituicaoProjetoPesquisa = (idProjetoPesquisa, idInstituicaoProjetoPesquisa, instituicaoProjetoPesquisa) => {
  const INSTITUICAO_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/instituicoes/' + idInstituicaoProjetoPesquisa
  let config = {
    method: 'put',
    url: INSTITUICAO_URL,
    responseType: 'text',
    credentials: true,
    body: instituicaoProjetoPesquisa
  }
  return Vue.http(config)
}

// Exclui uma instituição de um projeto de pesquisa.
const deleteInstituicaoProjetoPesquisa = (idProjetoPesquisa, idInstituicaoProjetoPesquisa) => {
  const INSTITUICAO_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/instituicoes/' + idInstituicaoProjetoPesquisa
  let config = {
    method: 'delete',
    url: INSTITUICAO_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

// Retorna lista de países.
const getPaisesInstituicaoProjetoPesquisa = () => {
  const PAISES_INSTITUICAO_URL = API_URL + '/pesquisa/paises-instituicao'
  let config = {
    method: 'get',
    url: PAISES_INSTITUICAO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Retorna lista de estados.
const getEstadosInstituicaoProjetoPesquisa = () => {
  const ESTADOS_INSTITUICAO_URL = API_URL + '/pesquisa/estados-instituicao'
  let config = {
    method: 'get',
    url: ESTADOS_INSTITUICAO_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Cadastra uma nova instituição.
const postInstituicao = (instituicao) => {
  const INSTITUICAO_URL = API_URL + '/pesquisa/instituicoes'
  let config = {
    method: 'post',
    url: INSTITUICAO_URL,
    responseType: 'text',
    credentials: true,
    body: instituicao
  }
  return Vue.http(config)
}

// Adiciona um participante a um projeto de pesquisa.
const postParticipanteProjetoPesquisa = (idProjetoPesquisa, participanteProjetoPesquisa) => {
  const PARTICIPANTE_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/participantes'
  let config = {
    method: 'post',
    url: PARTICIPANTE_URL,
    responseType: 'text',
    credentials: true,
    body: participanteProjetoPesquisa
  }
  return Vue.http(config)
}

// Retorna um determinado participante de um projeto de pesquisa.
const getParticipanteProjetoPesquisa = (idProjetoPesquisa, idParticipanteProjetoPesquisa) => {
  const PARTICIPANTE_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/participantes/' + idParticipanteProjetoPesquisa
  let config = {
    method: 'get',
    url: PARTICIPANTE_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

// Edita um participante de um projeto de pesquisa.
const putParticipanteProjetoPesquisa = (idProjetoPesquisa, idParticipanteProjetoPesquisa, participanteProjetoPesquisa) => {
  const PARTICIPANTE_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/participantes/' + idParticipanteProjetoPesquisa
  let config = {
    method: 'put',
    url: PARTICIPANTE_URL,
    responseType: 'text',
    credentials: true,
    body: participanteProjetoPesquisa
  }
  return Vue.http(config)
}

// Exclui um participante de um projeto de pesquisa.
const deleteParticipanteProjetoPesquisa = (idProjetoPesquisa, idParticipanteProjetoPesquisa) => {
  const PARTICIPANTE_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/participantes/' + idParticipanteProjetoPesquisa
  let config = {
    method: 'delete',
    url: PARTICIPANTE_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

// Exclui um arquivo de um projeto de pesquisa.
const deleteArquivoProjetoPesquisa = (idProjetoPesquisa, idArquivoProjetoPesquisa) => {
  const ARQUIVOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/arquivos/' + idArquivoProjetoPesquisa
  let config = {
    method: 'delete',
    url: ARQUIVOS_URL,
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

// Adiciona um arquivo a um projeto de pesquisa.
const postArquivoProjetoPesquisa = (idProjetoPesquisa, arquivo) => {
  const ARQUIVOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/arquivos'
  let config = {
    method: 'post',
    url: ARQUIVOS_URL,
    responseType: 'json',
    credentials: true,
    body: arquivo
  }
  return Vue.http(config)
}

// Edita as informações de um determinado arquivo de um projeto de pesquisa.
const putArquivoProjetoPesquisa = (idProjetoPesquisa, idArquivoProjetoPesquisa, arquivo) => {
  const ARQUIVOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/arquivos/' + idArquivoProjetoPesquisa
  let config = {
    method: 'put',
    url: ARQUIVOS_URL,
    responseType: 'json',
    credentials: true,
    body: arquivo
  }
  return Vue.http(config)
}

// Retorna as informações de um determinado arquivo de um projeto de pesquisa.
const getArquivoProjetoPesquisa = (idProjetoPesquisa, idArquivoProjetoPesquisa) => {
  const ARQUIVOS_URL = API_URL + '/pesquisa/projetos/' + idProjetoPesquisa + '/arquivos/' + idArquivoProjetoPesquisa + '/informacoes'
  let config = {
    method: 'get',
    url: ARQUIVOS_URL,
    responseType: 'text',
    credentials: true
  }
  return Vue.http(config)
}

export default {
  getOpcoesTabelaEstruturada,
  getProjetoSIEX,
  getRelatorioProjeto,
  getMeusProjetos,
  getMeusProjetosAtivos,
  getConsultaProjetos,
  getConsultaRelatoriosTecnicos,
  getProjeto,
  deleteProjeto,
  getClassificacoesPossiveis,
  getClassificacoesAreasDoConhecimento,
  getClassificacoesClassificacaoSuperior,
  getClassificacoesDoProjeto,
  getExtensaoDoProjeto,
  getContatosDoProjeto,
  getIntegrantesDoProjeto,
  getVinculosDoProjeto,
  getParceriasDoProjeto,
  getAtividadesDoProjeto,
  getSuspensoes,
  getAtividade,
  deleteAtividade,
  getParceria,
  putAtividade,
  getBolsasDoProjeto,
  getArquivosDoProjeto,
  getArquivo,
  getPessoasPorNome,
  getPessoasPorCpf,
  getPessoa,
  putPessoa,
  getUnidadesExtensao,
  getUnidades,
  postProjeto,
  postClassificacoesDoProjeto,
  postParceriasDoProjeto,
  putParceriasDoProjeto,
  postAtividadesDoProjeto,
  putProjeto,
  getIntegrante,
  postIntegrante,
  postImportarProjetoSIEX,
  putIntegrante,
  putCoordenador,
  deleteIntegrante,
  postExtensao,
  postContatos,
  postRelatorio,
  postBolsista,
  postArquivo,
  putArquivo,
  deleteArquivo,
  deleteParceria,
  getListaLocalidade,
  getLocalidade,
  postLocalidade,
  putLocalidade,
  deleteLocalidade,
  getCidades,
  getEstados,
  postPessoa,
  getAcaoExtensao,
  postSubmissaoAprovacao,
  postConcluirImportacao,
  postAprovarProjeto,
  postDevolverProjeto,
  postLiberarRelatorioFinal,
  postInabilitarProjeto,
  postAlterarClassificacaoSecundaria,
  postSuspenderAcaoExtensao,
  postReativarAcaoExtensao,
  postProrrogarSuspensaoAcaoExtensao,
  postSubmissaoConclusao,
  getParcerias,
  getOcorrenciasIntegrante,
  postFinalizarProjeto,
  postConcluirProjeto,
  postCancelarProjeto,
  getRelatoriosGestao,
  postDesfazerFinalizacaoProjeto,
  postDesfazerExclusaoProjeto,
  postProjetoSuperior,
  getProjetosVencidos,
  getProjetosComRelatorioReprovavel,
  getRegistrosDeEnvioDeRelatorioDeProjeto,
  getListaMensagem,
  postMensagem,
  deleteProjetoSuperior,
  getDuplicacao,
  postDuplicacao,
  getRelatoriosDoProjeto,
  getRelatorioExtensao,
  postRelatorioExtensao,
  putRelatorioExtensao,
  postSubmeterRelatorio,
  postAprovarRelatorio,
  postDevolverRelatorio,
  postReprovarRelatorio,
  postReprovarRelatorioComSuspensaoDeCoordenador,
  postRegistrarEnvioDeRelatorioDeProjeto,
  deleteRegistroEnvioDeRelatorioDeProjeto,
  putRegistroEnvioDeRelatorioDeProjeto,
  postAtivarAdministrador,
  postDesativarAdministrador,
  getPrazoDias,
  getRelatorioTecnicoForaPrazo,
  getVerificarPendenciasRelatorio,
  getPeriodoRelatorio,
  getEmailCargaHorariaCoordenador,
  getExcadServer,
  getDocumentoProtocolo,
  postProjetoPesquisa,
  getConsultaProjetosPesquisa,
  postProjetoPesquisaRegistro,
  getMeusProjetosPesquisa,
  getProjetoPesquisa,
  getInstituicoesProjetoPesquisa,
  getParticipantesProjetoPesquisa,
  getOrgaosFinanciadoresProjetoPesquisa,
  putProjetoPesquisa,
  getPesquisaOrgaosFinanciadoresPorNome,
  getPesquisaOrgaosFinanciadoresPorSigla,
  getOrgaoFinanciador,
  postOrgaoFinanciadorProjetoPesquisa,
  getOrgaoFinanciadorProjetoPesquisa,
  putOrgaoFinanciadorProjetoPesquisa,
  deleteOrgaoFinanciadorProjetoPesquisa,
  postOrgaoFinanciador,
  getPesquisaInstituicoesPorNome,
  getPesquisaInstituicoesPorSigla,
  getInstituicao,
  postInstituicaoProjetoPesquisa,
  getInstituicaoProjetoPesquisa,
  putInstituicaoProjetoPesquisa,
  deleteInstituicaoProjetoPesquisa,
  getPaisesInstituicaoProjetoPesquisa,
  getEstadosInstituicaoProjetoPesquisa,
  postInstituicao,
  postParticipanteProjetoPesquisa,
  getParticipanteProjetoPesquisa,
  putParticipanteProjetoPesquisa,
  deleteParticipanteProjetoPesquisa,
  getArquivosProjetoPesquisa,
  deleteArquivoProjetoPesquisa,
  postArquivoProjetoPesquisa,
  putArquivoProjetoPesquisa,
  getArquivoProjetoPesquisa,
  postRegistrarProjetoPesquisa,
  postDevolverProjetoPesquisa,
  postConcluirProjetoPesquisa,
  postCancelarProjetoPesquisa
}



// WEBPACK FOOTER //
// ./src/utils/projetos.js